import { pairingSlice } from "./reducer";

export const { closeWizard, openWizard } = pairingSlice.actions;
